import React from "react";

function SavingHeading({
  firstline,
  secondline,
  secondlineBlue = "",
  thirdline = "",
  thirdlineblue = "",
}) {
  return (
    <h1 className="font-IvyJournal font-semibold text-[22px] leading-[27.85px] md:text-[42px] md:leading-[65.2px] text-[#002045]">
      {firstline} <br className="hidden lg:block" /> {secondline}{" "}
      <span className="text-blueish">{secondlineBlue}</span>{" "}
      <br className="hidden lg:block" /> {thirdline}{" "}
      <span className="text-blueish">{thirdlineblue}</span>
    </h1>
  );
}

export default SavingHeading;
